import { render, staticRenderFns } from "./112.vue?vue&type=template&id=275332ef&scoped=true&"
var script = {}
import style0 from "./112.vue?vue&type=style&index=0&id=275332ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275332ef",
  null
  
)

export default component.exports